// Outside mail to the Receiving team that's Fulfillment's own business (a
// reorder it chased itself). Solicitors answer shortage chases to Proxy, and
// Proxy tells Fulfillment in Ace (contexts/TeamMessagesContext).
export interface WayneInboxEmail {
  id: string;
  from: string;
  to: string;
  subject: string;
  preview: string;
  date: string;
  time: string;
  unread: boolean;
  body: string;
  client: string;
  scan: string;
  jobNumber: string;
}

export const WAYNE_INBOX_EMAILS: WayneInboxEmail[] = [
  {
    id: 'horizon-group',
    from: 'corporate.secretary@horizongroupproperties.com',
    to: 'Receiving Team <ops@wayne.betanxt.com>',
    subject: 'Re: Follow-up — Horizon Group Properties Inc, job #3060015',
    preview: 'Reorder batch confirmed, dispatching this week...',
    date: 'Yesterday · 3:20 PM',
    time: 'Yesterday · 3:20 PM',
    unread: false,
    body: `Dear Team,\n\nThis confirms the reorder batch for Horizon Group Properties Inc (Job #3060015, scan S-P15) has been approved and will dispatch this week.\n\nThank you for flagging this.\n\nHorizon Group Properties Inc\nCorporate Secretary`,
    client: 'Horizon Group Properties Inc',
    scan: 'S-P15',
    jobNumber: '3060015',
  },
];
